import { useEffect } from 'react';

export const useMediaProtection = () => {
  useEffect(() => {
    // Prevenir clic derecho en todo el documento
    const handleContextMenu = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Solo prevenir en imágenes y videos
      if (target.tagName === 'IMG' || target.tagName === 'VIDEO') {
        e.preventDefault();
        return false;
      }
    };

    // Prevenir arrastrar imágenes y videos
    const handleDragStart = (e: DragEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'IMG' || target.tagName === 'VIDEO') {
        e.preventDefault();
        return false;
      }
    };

    // Prevenir atajos de teclado para guardar
    const handleKeyDown = (e: KeyboardEvent) => {
      // Prevenir Ctrl+S, Ctrl+Shift+S, Ctrl+A, Ctrl+C (cuando está sobre media)
      if (
        (e.ctrlKey && e.key === 's') ||
        (e.ctrlKey && e.shiftKey && e.key === 'S') ||
        (e.ctrlKey && e.key === 'a' && (e.target as HTMLElement)?.tagName === 'IMG') ||
        (e.ctrlKey && e.key === 'c' && (e.target as HTMLElement)?.tagName === 'IMG')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Aplicar protección a todas las imágenes y videos existentes
    const protectMedia = () => {
      const images = document.querySelectorAll('img');
      const videos = document.querySelectorAll('video');

      images.forEach((img) => {
        img.setAttribute('draggable', 'false');
        img.style.userSelect = 'none';
        img.style.webkitUserSelect = 'none';
        (img.style as any).webkitUserDrag = 'none';
      });

      videos.forEach((video) => {
        video.setAttribute('draggable', 'false');
        video.setAttribute('controlsList', 'nodownload noplaybackrate');
        video.setAttribute('disablePictureInPicture', 'true');
        video.style.userSelect = 'none';
        video.style.webkitUserSelect = 'none';
        (video.style as any).webkitUserDrag = 'none';
      });
    };

    // Observador para proteger nuevos elementos añadidos dinámicamente
    const observer = new MutationObserver(() => {
      protectMedia();
    });

    // Proteger elementos existentes
    protectMedia();

    // Observar cambios en el DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Añadir event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('keydown', handleKeyDown);
      observer.disconnect();
    };
  }, []);
};

